import {useMemo} from 'react';
import { UserDetails } from '../types/schemas/abc';

export const useSubjectGrid = (expertise: UserDetails['expertise']) => {
    const subjectsByLevel = useMemo(() => {
        if (!expertise) return new Map<string, Set<string>>();

        const expertiseMap = new Map<string, Set<string>>();
        for (const [subject, levels] of Object.entries(expertise)) {
            expertiseMap.set(subject, new Set(levels));
        }
        return expertiseMap;
    }, [expertise]);

    const subjects = useMemo(() => 
        Array.from(subjectsByLevel.keys()).sort(), 
    [subjectsByLevel,
    ]) 

    const sortedLevels = useMemo(() => {
        if (!expertise) return [];

        const levelCounts: {[level: string]: number } = {}; 

        Object.values(expertise).forEach((levelArray) => {
            levelArray.forEach((level) => {
                if (!levelCounts[level]) {
                    levelCounts[level] = 0;
                }
                levelCounts[level]++;
            });
        });

        return Object.keys(levelCounts)
            .map((level) => ({level, count: levelCounts[level]}))
            .sort((a,b) => b.count - a.count);
    
    }, [expertise]);

    const gridColumns = useMemo(() => {
        const subjectColumn = 'max-content';
        const topLevels = new Set(sortedLevels
            .slice(0, 2)
            .map((item) => item.level));
        
        const levelColumns = sortedLevels
            .map(({level}) => {
                if (topLevels.has(level)) {
                    return 'minmax(195px, 1.5fr)';
                }
                return 'minmax(130px, 1fr)'
            })
            .join(' ');
          return `${subjectColumn} ${levelColumns}`;
    }, [sortedLevels]);


    return {subjectsByLevel, subjects, sortedLevels, gridColumns}
    
}